// extracted by mini-css-extract-plugin
export var menuIcon = "_ui-0";
export var menuIconInline = "_ui-1";